import { useEffect, useState } from "react"
import { SystemConstants } from "src/common/constants"
import { SearchableTable } from "src/components/SearchableTable"
import { DateRanges } from "src/components/SearchableTable/types"
import moment from "moment"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "src/state/reducer"
import { serviceLoading } from "src/common/apiLoader/state/selection"
import { GET_PAYABLE_CONTRACT_PAYMENTS_API } from "../state/actionTypes"
import { ColumnsType } from "antd/es/table"
import { SystemDescriptions } from "src/common/descriptions"
import { PayableContractPayment, PayableContractPaymentRecordsFilters } from "src/common/models/payableContractDebitPayment"
import { summaryColumns, TABLE_COLUMNS } from "./config"
import dayjs from 'dayjs'
import { getPayableContractPaymentRecordsApi } from "../state/action"

interface ReduxProps {
    contractPayments?: PayableContractPayment[],
    isGettingContractPayments: boolean
}

export const PayablePaymentsComponent = () => {
    const dispatch = useDispatch()

    const [dateRanges, setDateRanges] = useState<DateRanges>({
        startDate: moment().startOf('month').format(SystemConstants.DATETIME_QUERY(true)),
        endDate: moment().format(SystemConstants.DATETIME_QUERY(false)),
    })

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        contractPayments: state.accountPayables.contractPayments || [],
        isGettingContractPayments: serviceLoading(state, [GET_PAYABLE_CONTRACT_PAYMENTS_API]),
    }))

    const descriptions = SystemDescriptions.PAGES.PAYABLE_CONTRACT.PAYABLE_CONTRACT_PAYMENTS

    useEffect(() => {
        fetchRecords()
    }, [])

    const tblColumns: ColumnsType<PayableContractPayment> = [
        ...TABLE_COLUMNS,
    ]

    const handleDateRangesChange = (dateRanges: DateRanges) => {
        setDateRanges({
            startDate: moment(dateRanges.startDate).format(SystemConstants.DATETIME_QUERY(true)),
            endDate: moment(dateRanges.endDate).format(SystemConstants.DATETIME_QUERY(false)),
        })
    }

    const handleActionButtonClick = () => {
        fetchRecords()
    }

    const fetchRecords = () => {
        const payload: PayableContractPaymentRecordsFilters = {
            dateFrom: dateRanges.startDate,
            dateTo: dateRanges.endDate,
        }

        dispatch(getPayableContractPaymentRecordsApi(payload))
    }

    return (
        <SearchableTable
            showSearch
            showLoader={reduxProps.isGettingContractPayments}
            items={reduxProps.contractPayments || []}
            tableColumns={tblColumns as any}
            searchLabel={descriptions.TABLE.SEARCH_PLACEHOLDER}
            showRangePicker
            rangePickerOnChange={handleDateRangesChange}
            rangePickerDefaultValues={[dayjs().startOf('month'), dayjs()]}
            actionButtonLabel={descriptions.TABLE.ACTION_BUTTON}
            showActionButton
            actionButtonOnClick={handleActionButtonClick}
            summaryColumns={summaryColumns}
        />
    )
}
